export enum AudioPlaybackState {
    Paused,
    PlayingTimeline,
    PlayingAudioFile,
}

export interface IAudioPlayback {
    projectActive: boolean;
    state: AudioPlaybackState;
    timelineTime: number;
    audioFileId: number | null;
}